import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M59.2299 22.64C61.2099 23.63 64.5099 23.14 64.5099 23.14C58.5699 20 55.9199 1.17993 55.9199 1.17993H12.4999C12.4999 1.17993 9.85991 20.01 3.90991 23.14C3.90991 23.14 7.20991 23.64 9.18991 22.64C9.18991 22.64 7.36991 28.42 5.71991 30.9C5.71991 30.9 8.3599 30.24 10.0099 29.08C10.0099 29.08 9.1799 35.69 12.9799 38.16C12.9799 38.16 12.1499 34.1999 13.1499 32.5499C13.1499 32.5499 15.1299 35.85 16.9499 37.34C18.7699 38.83 19.9199 41.47 19.9199 41.47L20.2499 35.6899C20.2499 35.6899 21.7399 39.65 26.3599 41.14C30.9799 42.63 32.9699 43.95 32.9699 43.95H35.4499C35.4499 43.95 37.4299 42.63 42.0599 41.14C46.6799 39.65 48.1699 35.6899 48.1699 35.6899L48.4999 41.47C48.4999 41.47 49.6599 38.83 51.4699 37.34C53.2899 35.85 55.2699 32.5499 55.2699 32.5499C56.2599 34.1999 55.4399 38.16 55.4399 38.16C59.2399 35.68 58.4099 29.08 58.4099 29.08C60.0599 30.24 62.6999 30.9 62.6999 30.9C61.0499 28.42 59.2299 22.64 59.2299 22.64Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
